import { ThemeProvider } from 'styled-components';
import { createContext, useContext } from 'react';

import { themeDetails } from './themeConstants';
import { ThemeState, CustomThemeProviderProps } from './types';

const defaultState = themeDetails['coterie'];

export const ThemeContext = createContext<ThemeState>(defaultState);
export const useThemeContext = () => useContext(ThemeContext);

const CustomThemeProvider = ({ children }: CustomThemeProviderProps) => {
  return (
    <ThemeContext.Provider
      value={{
        theme: defaultState.theme,
        logo: defaultState.logo,
      }}
    >
      <ThemeProvider theme={defaultState.theme}>{children}</ThemeProvider>
    </ThemeContext.Provider>
  );
};

export default CustomThemeProvider;
